module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA/UlEQVRYR8XXjQ2CMBCG4a9dQDbw0EUYQTeQyXQDHcERXAA4N3ACapDExBjo313KALwPtOmPQeHHFO7DCyCiBrBXAC9gbJn5Lon2A+odA2b7jTq0zN1FCrEKIKIKxk6AzU9QEOH/A7Q/weD898VCCC9gCpMiIgigiQgGaCGiABqIaIA0IgkgiUgGSCGyABKIbIAHcWTubmvLtghgEeEcM/d1OQDck4ee1AErS7X+EOTuE1lzIDc+DU0yQCKeDJCKJwEk49EA6XgUQCMeDNCKBwE0417A51gOO8CYqtyxvOTFZN7lqIGx803IjQdmfkjdirxDIBlaelfyUiyFewPliKsh6fQtvQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/right.png
// module id = gMJA
// module chunks = 1